import React from "react";
import { Layout } from "antd";
import styled, { withTheme, css } from "styled-components";
import { getImagePath } from "@educhain/utils/theme/getImagePath";
import { THEME_UAEU } from "@educhain/themes/src";
const {
  Header: AntHeader
} = Layout;
const StyledHeader = styled(AntHeader)`
    ${props => !!props.theme.value === THEME_UAEU && css`
            @font-face {
                font-family: "Dubai";
                src: local("Dubai"),
                    url(${props => getImagePath(props.theme.assets.brandFont)})
                        format("woff");
                font-style: normal;
            }
        `}

    display: flex;
    background: white;
    margin: 0 30px 0 30px;
    justify-content: space-between;
    padding: 0;
    height: 75px;
    line-height: 75px;

    .page-title {
        font-family: Dubai, Roboto, sans-serif;
        color: ${({
  theme: {
    colors
  }
}) => colors.primaryLight};
        font-weight: 600;
        text-transform: capitalize;
        font-size: 20px;
        @media (min-width: 600px) {
            padding: 0 15px;
            font-size: 24px;
        }
        @media (max-width: 450px) {
            display: none;
        }
    }

    .nav-item {
        padding: 0 15px;
    }
`;
const Wrapper = styled.div`
    background-color: white;
    box-shadow: 0 2px 8px #f0f1f2;
    z-index: 1;
`;
const ImageWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 75px;
    flex: 1;
`;
const Logo = styled.img`
    max-height: 40px;
    width: auto;
`;
const RightWrapper = styled.div`
    display: flex;
    flex-direction: row;

    a {
        margin: 0 5px;
    }
`;

const BaseHeader = ({
  theme,
  title
}) => {
  return React.createElement(Wrapper, null, React.createElement(StyledHeader, null, React.createElement(ImageWrapper, null, React.createElement(Logo, {
    alt: "",
    src: getImagePath(theme.assets.logo)
  })), React.createElement(RightWrapper, null, title && React.createElement("div", {
    className: "page-title"
  }, title))));
};

export const Header = withTheme(BaseHeader);